import axios from 'axios';

// Use environment variable or default to empty string (same domain)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

// Get or create user ID for session tracking
const getUserId = () => {
  let userId = localStorage.getItem('beneficiaries_user_id');
  if (!userId) {
    userId = `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('beneficiaries_user_id', userId);
  }
  return userId;
};

// API calls
export const api = {
  // Get all game stages
  getStages: async () => {
    try {
      const response = await axios.get(`${API}/stages`);
      return response.data;
    } catch (error) {
      console.error('Error fetching stages:', error);
      throw error;
    }
  },

  // Get challenges for a specific stage
  getChallenges: async (stageId) => {
    try {
      const response = await axios.get(`${API}/challenges/${stageId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching challenges for stage ${stageId}:`, error);
      throw error;
    }
  },

  // Get user progress
  getUserProgress: async () => {
    try {
      const userId = getUserId();
      const response = await axios.get(`${API}/user/progress`, {
        headers: {
          'X-User-Id': userId
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching user progress:', error);
      throw error;
    }
  },

  // Update user progress
  updateUserProgress: async (stageId, score, attempts) => {
    try {
      const userId = getUserId();
      const response = await axios.post(
        `${API}/user/progress`,
        {
          stageId,
          score,
          attempts
        },
        {
          headers: {
            'X-User-Id': userId
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating user progress:', error);
      throw error;
    }
  },

  // Track knowledge base visit
  trackKnowledgeBaseVisit: async (stageId, attempts) => {
    try {
      const userId = getUserId();
      const response = await axios.post(`${API}/knowledge-base/track`, {
        userId,
        stageId,
        attempts,
        timestamp: new Date().toISOString()
      });
      return response.data;
    } catch (error) {
      console.error('Error tracking knowledge base visit:', error);
      // Don't throw error for tracking - it's not critical
      return null;
    }
  }
};

export default api;
